<div class="form-group has-clear position-relative mb-3">
  <div class="col">
    <label for="trackSearch" class="form-label">Track</label>
    <input type="text"
           class="form-control"
           name="trackSearch"
           placeholder="Search tracks"
           [(ngModel)]="model"
           [ngbTypeahead]="searchTracks"
           [resultTemplate]="rt2"
           [inputFormatter]="trackInputFormatter"
           (focus)="focusTrackSearch$.next($any($event).target.value)"
           (click)="clickTrackSearch$.next($any($event).target.value)"
           (selectItem)="selectTrack($any($event).item)"
           [editable]="false"
           #trackSearch="ngbTypeahead" />

    <span class="form-control-clear fa-solid fa-times form-control-feedback" (click)="clearTrack()"></span>
    <ng-template #rt2 let-r="result" let-t="term">
      <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
    </ng-template>
  </div>
</div>
